import type { Provider } from '@angular/core';

import { ClinicStatisticsService, STATISTICS_SCOPE_TEXT } from '../admin/clinic-statistics.service';
import { OwnerClinicStatisticsService } from './owner-clinic-statistics.service';

/**
 * Route providers that turn the super-admin Statistics page into the clinic
 * owner's Dashboard: data scoped server-side to the owner's clinics, and
 * wording that says "your clinics" instead of "the network".
 */
export const OWNER_STATISTICS_PROVIDERS: Provider[] = [
  { provide: ClinicStatisticsService, useClass: OwnerClinicStatisticsService },
  {
    provide: STATISTICS_SCOPE_TEXT,
    useValue: {
      title: 'owner.dashboard.title',
      subtitle: 'owner.dashboard.subtitle',
      kpiTitle: 'owner.dashboard.kpiTitle',
      compareTitle: 'owner.dashboard.compareTitle',
      median: 'owner.dashboard.median',
    },
  },
];
